import * as React from 'react'

import classNames from 'classnames'

import IAnswer from '../../data/questionnaires/IAnswer'
import IQuestion from '../../data/questionnaires/IQuestion'

import { Button, Grid } from '@material-ui/core'

import Answer from './Answer'
import Question from './Question'
import TopBar from './TopBar'

import { PopupLoader } from 'components'

import './style.scss'

interface IProps {
  question: IQuestion
  activeQuestion: number
  activeAnswer: number | null
  questionsCount: number
  answers: IAnswer[]
  backAction: (toMainPage?: boolean) => void
  nextAction: () => void
  setAnswer: (i: number) => void
  estimatedTime: number
  title: string
  loading?: boolean
  setInRow: (callback: any) => void
}

interface IState {}

class Content extends React.Component<IProps, IState> {
  // componentDidMount() {
  //   window.history.pushState(
  //     null,
  //     '',
  //     `/children_list/${this.props.child.patientId}/questionnaires`
  //   )
  //   window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  //   window.history.back()
  // }

  // onBackBrowserBtnEvent = event => {
  //   event.preventDefault()

  //   window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  //   window.history.back()
  //   // this.props.backAction(true)
  // }

  render() {
    const {
      backAction,
      nextAction,
      activeQuestion,
      activeAnswer,
      questionsCount,
      question,
      answers,
      setAnswer,
      estimatedTime,
      title,
      loading,
      setInRow
    } = this.props
    const answersRow = answers.length > 2
    return (
      <Grid
        container={true}
        direction="column"
        justify="space-between"
        alignItems="center"
        className="questions-page mobile-container"
      >
        <TopBar
          backAction={backAction}
          activeQuestion={activeQuestion}
          questionsCount={questionsCount}
          estimatedTime={estimatedTime}
          title={title}
          setInRow={setInRow}
        />
        <div className="question-container">
          <Question question={question} />
          <div className={classNames('answers', answersRow && 'answers-row')}>
            {answers.map((a, i) => (
              <Answer
                key={`${activeQuestion}-${i}`}
                answer={a}
                onClick={() => setAnswer(i)}
                active={activeAnswer !== null && i === activeAnswer}
                colored={answersRow}
              />
            ))}
          </div>
          {activeQuestion === questionsCount - 1 && (
            <div className="next-button-wrap">
              <Button
                disabled={activeAnswer === null}
                onClick={nextAction}
                color="primary"
                className="black-btn next-button"
              >
                Done
              </Button>
            </div>
          )}
        </div>
        <PopupLoader active={loading} />
      </Grid>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/Questionnaires/content.tsx